export default __webpack_public_path__ + "static/media/prize-5.8e610124.webp";